import React, {FC, useEffect, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import iconStateDisabled from "assets/icons/commons/source-state-disabled.svg"
import iconStateSuccess from "assets/icons/commons/source-state-active.svg"
import iconStateError from "assets/icons/commons/source-state-error.svg"
import ToggleButton from "../../ToggleButton";
import {DataSource} from "../../../../constants/DataSource/DataSource";
import {DataSourceStatus} from "../../../../constants/DataSource/DataSourceStatus";
import {t} from "i18next";
import Input from "../../../commons/Input/Input";
import FormSelect, {ISelectOption} from "../../../commons/Select/FormSelect";
import {v4 as uuidv4} from "uuid";
import classNames from "classnames";
import Number from "../../../commons/Input/Number";
import {FrequencySelector} from "../../FrequencySelector";
import {RuleRow, StockConvertRule} from "./RuleRow";
import plus from "../../../../assets/icons/commons/roundPlus.svg";
import {Button} from "../../../buttons";

const initialStockConvertRule: StockConvertRule = {
  contains: '',
  operator: '=',
  count: 0,
}

interface DataSourceProps {
  code: string
  data: DataSource|null
  updateDataSourceHandler: (code: string, payload: DataSource|null) => void
  toggleIsDisclosed: (code: string) => void
  toggleItemStatus: (code: string, isActive: boolean) => void
  isDisclosed: boolean
  isActive: boolean
}

export const EmailCSV: FC<DataSourceProps> = ({
  code,
  data,
  updateDataSourceHandler,
  toggleIsDisclosed,
  toggleItemStatus,
  isDisclosed,
  isActive
}) => {

  const title = 'Email с файлом CSV'

  const onStatusChange = (isActiveStatus: boolean) => {
    isActive = isActiveStatus
    toggleItemStatus(code, isActive)
  };

  // Param - sender
  const [sender, setSender] = useState('');

  // Param - frequency
  const onUpdateFrequencyChange = (frequency: number) => {
    setUpdateFrequency(frequency)
  };
  const [updateFrequency, setUpdateFrequency] = useState(0);

  // Param - skip rows
  const [skipRows, setSkipRows] = useState<number>(1);

  // Param - stocks field in source
  const [stocksColumnNumberInSource, setStocksColumnNumberInSource] = useState<number>(2);

  // Param - identity field in source
  const [identityColumnNumberInSource, setIdentityColumnNumberInSource] = useState<number>(1);

  // Param - separator
  const availableSeparators: {[key: string]: string} = {
    ",": ",",
    ";": ";",
  }
  const defaultSeparator = ","
  const [separator, setSeparator] = useState(defaultSeparator);
  const [separatorOptions, setSeparatorOptions] = useState<ISelectOption[]>([]);

  // Param - internal identity field
  const availableMapByOptions: {[key: string]: string} = {
    "sku": "Артикул",
    "barcode": "Штрих-код",
    "id": "ID LK",
  }
  const defaultMapBy = "sku"
  const [mapBy, setMapBy] = useState(defaultMapBy);
  const [mapBySelectorOptions, setMapBySelectorOptions] = useState<ISelectOption[]>([]);

  // Param - stock convert rules
  const [stockConvertRules, setStockConvertRules] = useState<StockConvertRule[]>([]);

  const [errors, setErrors] = useState({sender: ''});

  // @ts-ignore
  const fieldsWithErrors = Object.keys(errors).filter((k: string) => errors[k].length > 0)
  const isFormHasErrors = (isActive && !sender) || fieldsWithErrors.length > 0
  const state = isActive ? (isFormHasErrors ? 'fail' : 'success') : 'disabled'
  const dataSourceStateIconAssets = {
    'disabled': iconStateDisabled,
    'success': iconStateSuccess,
    'fail': iconStateError
  }

  useEffect(() => {
    //
    const separatorOptions: ISelectOption[] = []
    for (const key in availableSeparators) {
      separatorOptions.push({text: availableSeparators[key], value: key})
    }
    setSeparatorOptions(separatorOptions)

    //
    const mapBySelectOptions: ISelectOption[] = []
    for (const key in availableMapByOptions) {
      mapBySelectOptions.push({text: availableMapByOptions[key], value: key})
    }
    setMapBySelectorOptions(mapBySelectOptions)
  }, [])

  useEffect(() => {
    console.log('EmailCSV useEffect - data', data)

    if (!data) {
      toggleItemStatus(code, false)
      console.log('EmailCSV useEffect - data !!!!!!!!!!!!!!!!!!')
    }

    // @ts-ignore
    setSender(data?.configMap.sender || '')
    // @ts-ignore
    setIdentityColumnNumberInSource(parseInt(data?.configMap.identityColumnNumberInSource || 1))
    // @ts-ignore
    setStocksColumnNumberInSource(parseInt(data?.configMap.stocksColumnNumberInSource || 2))
    // @ts-ignore
    setSkipRows(parseInt(data?.configMap.skipRows || 1))
    // @ts-ignore
    setMapBy(data?.configMap.mapBy || defaultMapBy)
    // @ts-ignore
    setSeparator(data?.configMap.separator || defaultSeparator)
    // @ts-ignore
    setStockConvertRules(data?.configMap?.stockConvertRules?.length > 0 ? JSON.parse(data?.configMap?.stockConvertRules) : [initialStockConvertRule])
    setUpdateFrequency(data?.updateFrequency || 0)
  }, [data])


  useEffect(() => {
    console.log('useEffect - sender')

    if (isActive) {
      errors.sender = isValidSender(sender) ? '' : 'Введите корректный Sender'
    } else {
      errors.sender = ''
      if (!sender) {
        data = null
        console.log('EmailCSV sender cleared', data)
        updateDataSourceHandler(code, data)
      }
    }
  }, [sender, isActive])

  useEffect(() => {
    console.log('useEffect - sender, updateFrequency, status')

    if (!data && (sender || isActive)) {
      data = {
        uuid: uuidv4(),
        code: code,
        configMap: {},
        name: title,
        status: isActive ? DataSourceStatus.Current : DataSourceStatus.Archived,
        updateFrequency: 0,
      }
      console.log('EmailCSV set initial data', data)
    }

    if (data) {
      data.updateFrequency = updateFrequency
      const rr = stockConvertRules.filter(v => ['isN', 'isNaN'].includes(v.operator) || v.contains.length > 0)
      data.configMap = {
        sender: sender,
        skipRows: skipRows.toString(),
        identityColumnNumberInSource: identityColumnNumberInSource.toString(),
        stocksColumnNumberInSource: stocksColumnNumberInSource.toString(),
        mapBy: mapBy,
        separator: separator,
        stockConvertRules: JSON.stringify(rr),
      }
      updateDataSourceHandler(code, data)
      console.log('updateDataSourceHandler', data)
    }

    console.log('EmailCSV! data', data)

  }, [sender, identityColumnNumberInSource, mapBy, stocksColumnNumberInSource, skipRows, updateFrequency, separator, isActive, stockConvertRules])

  function isValidSender(sender: string) {
    var res = sender.match(/^[A-Za-z0-9а-яА-Я\._-]+@([A-Za-z0-9а-яА-Я]{1,2}|[A-Za-z0-9а-яА-Я]((?!(\.\.))[A-Za-z0-9а-яА-Я.-])+[A-Za-z0-9а-яА-Я])\.[A-Za-zа-яА-Я]{2,}$/);
    return (res !== null)
  }

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  function updateFrequencyHandler(e: any): void {
    setUpdateFrequency(parseInt(e.target.value))
  }

  function setStockConvertRulesDecorator(rr: StockConvertRule[]) {
    setStockConvertRules(rr)
  }

  function deleteStockConvertRule(position: number) {
      if (position === 0 && stockConvertRules.length === 1) {
        setStockConvertRulesDecorator([initialStockConvertRule])
      } else {
        setStockConvertRulesDecorator(stockConvertRules.filter((_, i) => i !== position))
      }
  }

  function updateStockConvertRules(position: number, data: StockConvertRule) {
      if (position === 0 && stockConvertRules.length === 1) {
        setStockConvertRulesDecorator([data])
      } else {
        setStockConvertRulesDecorator(stockConvertRules.map((v, i) => i === position ? {...data} : v))
      }
  }

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
    >
      <div className="flex max-h-11 rounded items-center justify-between" onClick={() => toggleIsDisclosed(code)}>
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
            <img src={dataSourceStateIconAssets[state]} className="mr-2" />
            {title}
          </div>
        </div>
        <div className="flex items-center">
          <ToggleButton
            label="Подключен"
            labelId="название-опции-тут"
            onChange={onStatusChange}
            isChecked={isActive}
          />
          <div>
            <div>
              <img src={isDisclosed ? path_up : path_down} alt={''} />
            </div>
          </div>
        </div>

      </div>
      {isDisclosed && (
          <div className={'mt-4'}>
            <Input
                placeholder="from@mail.com"
                id="emailCSV_sender"
                name="emailCSV_sender"
                value={sender}
                label={t<string>("Отправитель", { ns: "messages" })}
                changeHandler={event => setSender(event.target.value)}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
                blurHandler={event => setSender(event.target.value)}
                validationError={errors.sender.length > 0}
                validationErrorDescription={errors.sender}
                type="email"
                require={false}
            />

            <div className="mt-4 flex flex-row">
              <div className={`w-1/2`}>
                <Number
                    id="emailCSV_skipRows"
                    name="emailCSV_skipRows"
                    value={skipRows}
                    label={t<string>("Пропустить строк в таблице", { ns: "messages" })}
                    changeHandler={event => setSkipRows(parseInt(event.target.value))}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setSkipRows(parseInt(event.target.value))}
                    min={0}
                    require={false}
                />
              </div>
              <div className={`p-4`}></div>
              <div className={`w-1/2`}>
                <FormSelect
                    id="emailCSV_separator"
                    name="emailCSV_separator"
                    value={separator}
                    label={t<string>("Разделитель значений", { ns: "messages" })}
                    changeHandler={event => setSeparator(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setSeparator(event.target.value)}
                    require={false}
                    options={separatorOptions}
                ></FormSelect>
              </div>
            </div>

            <div className="mt-4">
              <Number
                  id="emailCSV_stocksColumnNumberInSource"
                  name="emailCSV_stocksColumnNumberInSource"
                  value={stocksColumnNumberInSource}
                  label={t<string>("Номер колонки с остатками", { ns: "messages" })}
                  changeHandler={event => setStocksColumnNumberInSource(parseInt(event.target.value))}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={event => setStocksColumnNumberInSource(parseInt(event.target.value))}
                  min={0}
                  require={false}
              />
            </div>

            <div className="mt-4">
              Правила чтения остатков (приоритет правил - сверху-вниз)
            </div>
            <div className="mt-4">
              {stockConvertRules.map((r, k) =>
                  <RuleRow key={k} position={k} rulesCount={stockConvertRules.length} data={r} deleteRule={deleteStockConvertRule} updateDataHandler={updateStockConvertRules}></RuleRow>
              )}
              <div className={`text-right mt-4`}>
                <Button
                    clickHandler={() => setStockConvertRules([...stockConvertRules, initialStockConvertRule])}
                    appearance="primary"
                    customClassName="button-add"
                    type="button"
                >
                  <div className="flex justify-around w-[150px] items-center">
                    <img src={plus} alt="" className="w-4 h-4" />
                    <div>Добавить правило</div>
                  </div>
                </Button>
              </div>
            </div>

            <div className="mt-4">
              Сопоставить продукты по харатеристике
            </div>
            <div className="mt-4 flex flex-row">

              <div className={`w-1/2`}>
                <FormSelect
                    id="emailCSV_mapBy"
                    name="emailCSV_mapBy"
                    value={mapBy}
                    label={t<string>("LK", { ns: "messages" })}
                    changeHandler={event => setMapBy(event.target.value)}
                    customClassName={classNames(customInputClassName)}
                    customLabelClassName="text-sm"
                    blurHandler={event => setMapBy(event.target.value)}
                    validationError={false}
                    validationErrorDescription={''}
                    options={mapBySelectorOptions}
                    require={false}
                ></FormSelect>
              </div>
              <div className={`p-4 flex items-end`}>=</div>
              <div className={`w-1/2`}>
                <Number
                    id="emailCSV_identityColumnNumberInSource"
                    name="emailCSV_identityColumnNumberInSource"
                    value={identityColumnNumberInSource}
                    label={t<string>("Номер колонки в таблице", { ns: "messages" })}
                    changeHandler={event => setIdentityColumnNumberInSource(parseInt(event.target.value))}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setIdentityColumnNumberInSource(parseInt(event.target.value))}
                    min={0}
                    require={false}
                />
              </div>

            </div>

            <div className="mt-4 flex justify-between">
              <div className={"w-5/12"}>
                <FrequencySelector data={updateFrequency} onChange={onUpdateFrequencyChange}></FrequencySelector>
              </div>
              {data &&
                  <button
                      className="self-end items-center text-sm text-left font-medium mb-1 border-[1px] px-[15px] h-[42px] rounded mt-2 active:outline-none"
                      onClick={()=> {data = null; updateDataSourceHandler(code, data); console.log("DATA", data)}}
                      type={"button"}
                  >
                    Удалить источник
                  </button>
              }

            </div>

          </div>
      )}
    </div>
  );
};
